// extracted by mini-css-extract-plugin
module.exports = {"box":"_3t584b","brandContainer":"UXWQq5","brand":"_3fja8A","titleContainer":"_1kPMMQ","products":"_3wTb0L","product":"_2SwYkU","container":"IK2LRv","carousel":"_9m8psj"};